<template>
  <div class="wrapper">
    <menu-vigna
      msg="Hello"
      :is-dark-mode="isDarkMode"
      @toggle-dark-mode="toggleTheme"
    ></menu-vigna>
    <div class="content container-fluid">
      <router-view :is-dark-mode="isDarkMode" />
    </div>
    <footer-vigna></footer-vigna>
  </div>
</template>

<style lang="scss">
@import 'node_modules/bootstrap/scss/bootstrap';
@import '@/assets/scss/main.scss';
@import '@/assets/scss/footer.scss';
@import 'bootstrap-icons/font/bootstrap-icons.css';
</style>

<script>
import FooterVigna from './components/FooterVigna'
import MenuVigna from './components/MenuVigna'

export default {
  name: 'App',
  components: {
    MenuVigna,
    FooterVigna
  },
  data() {
    return {
      isDarkMode: false // Valeur par défaut
    }
  },
  methods: {
    // Basculer le thème
    toggleTheme() {
      this.isDarkMode = !this.isDarkMode
      const theme = this.isDarkMode ? 'dark' : 'light'
      document.documentElement.setAttribute('data-bs-theme', theme)
      this.setCookie('theme', theme, 7) // Sauvegarder dans les cookies
    },
    // Récupérer un cookie
    getCookie(name) {
      const nameEQ = `${name}=`
      const ca = document.cookie.split(';')
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i]
        while (c.charAt(0) === ' ') c = c.substring(1)
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length)
      }
      return null
    },
    // Définir un cookie
    setCookie(name, value, days) {
      const d = new Date()
      d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000)
      const expires = `expires=${d.toUTCString()}`
      document.cookie = `${name}=${value};${expires};path=/`
    },
    // Charger le thème à partir des cookies
    loadThemeFromCookie() {
      const savedTheme = this.getCookie('theme')
      if (savedTheme) {
        this.isDarkMode = savedTheme === 'dark'
        document.documentElement.setAttribute('data-bs-theme', savedTheme)
      }
    }
  },
  // Charger le thème à l'initialisation de l'application
  mounted() {
    this.loadThemeFromCookie()
  }
}
</script>
